import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-hours-day"
}
const _hoisted_2 = { class: "w-hours-heading" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "w-hours-columns" }
const _hoisted_5 = { class: "w-small" }
const _hoisted_6 = { class: "w-hours-list" }
const _hoisted_7 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_8 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_9 = ["aria-label", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "w-small"
}
const _hoisted_11 = ["disabled", "onClick"]

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import type { DraftDayKind } from '@/store/calendar/scheduleModule';
import type { HoursType } from '@/store/calendar/types';

type BranchDayEditorProps = {
  kind: DraftDayKind;
  index: number;
  title: string;
};

type HoursColumn = {
  type: HoursType;
  title: string;
  name: string;
  genitive: string;
  empty: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BranchDayEditor',
  props: {
    kind: {},
    index: {},
    title: {}
  },
  setup(__props: any) {

const COLUMNS: HoursColumn[] = [
  {
    type: 'open', title: 'Работа филиала', name: 'работа', genitive: 'работы', empty: 'Закрыто',
  },
  {
    type: 'intake', title: 'Приём пациентов', name: 'приём', genitive: 'приёма', empty: 'Приёма нет',
  },
];

const props = __props;

const store = useScheduleStore();

// День берётся из черновика по индексу — редактор меняет стор, а не свои props
const day = computed(() => store.draftDay(props.kind, props.index));

const onDayOffChange = (event: Event) => {
  store.setDayOff(props.kind, props.index, (event.target as HTMLInputElement).checked);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (day.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
          _createElementVNode("label", null, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: !day.value.open.length,
              onChange: onDayOffChange
            }, null, 40, _hoisted_3),
            _cache[2] || (_cache[2] = _createTextVNode(" Выходной ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COLUMNS, (column) => {
            return _createElementVNode("div", {
              key: column.type,
              class: "w-hours-column"
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(column.title), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.value[column.type], (interval, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "w-hours-interval"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((interval.start) = $event),
                      type: "time",
                      step: "60",
                      "aria-label": `${__props.title} · ${column.name} · начало ${index + 1}`,
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).markBranchEdited()))
                    }, null, 40, _hoisted_7), [
                      [
                        _vModelText,
                        interval.start,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { "aria-hidden": "true" }, "–", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((interval.end) = $event),
                      type: "time",
                      step: "60",
                      "aria-label": `${__props.title} · ${column.name} · окончание ${index + 1}`,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).markBranchEdited()))
                    }, null, 40, _hoisted_8), [
                      [
                        _vModelText,
                        interval.end,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "w-button w-ghost w-icon",
                      type: "button",
                      "aria-label": `${__props.title} · убрать интервал ${column.genitive} ${index + 1}`,
                      onClick: ($event: any) => (_unref(store).removeInterval(props.kind, props.index, column.type, index))
                    }, [
                      _createVNode(_component_q_icon, { name: "close" })
                    ], 8, _hoisted_9)
                  ]))
                }), 128)),
                (!day.value[column.type].length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(column.empty), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "w-button w-ghost",
                type: "button",
                disabled: column.type === 'intake' && !day.value.open.length,
                onClick: ($event: any) => (_unref(store).addInterval(props.kind, props.index, column.type))
              }, [
                _createVNode(_component_q_icon, { name: "add" }),
                _cache[4] || (_cache[4] = _createTextVNode(" Интервал ", -1))
              ], 8, _hoisted_11)
            ])
          }), 64))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})